import {
  Box,
  Button,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";
import TopicIcon from "@mui/icons-material/Topic";
import DescriptionIcon from "@mui/icons-material/Description";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { modalStyle } from "../../../../../../../../components/modalStyle";

export default function DocsBtnMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);

  const open = Boolean(anchorEl);
  const onClick = (event) => setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const onopenModal = () => setOpenModal(true);
  const onCloseModal = () => setOpenModal(false);

  const onClickDoc = (i) => {
    onopenModal();
    console.log(i);
  };
  const docsData = [1, 2, 3, 4, 5];
  return (
    <>
      <Button
        variant="outlined"
        endIcon={<TopicIcon />}
        sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
        onClick={onClick}
      >
        Docs
      </Button>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              //   transform: "translateY(50px)",
              mt: -1,
              minWidth: 200,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                bottom: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "bottom" }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
      >
        {docsData.map((doc, i) => {
          return (
            <MenuItem
              onClick={() => onClickDoc(doc)}
              key={doc}
              sx={{
                color: "#444",
                borderBottom: docsData.length === i + 1 ? "" : "1px solid #ddd",
                mx: 1,
              }}
            >
              {""}
              <DescriptionIcon sx={{ mr: 0.5 }} /> Doc {doc}
            </MenuItem>
          );
        })}
      </Menu>

      <Modal open={openModal} onClose={onCloseModal}>
        <Box sx={{ ...modalStyle, minHeight: 600 }}>
          <Typography variant="h6" component="h2">
            - Doc :{" "}
            <IconButton sx={{ float: "right" }} onClick={onCloseModal}>
              <HighlightOffIcon color="error" />
            </IconButton>
          </Typography>
          <Divider sx={{ my: 1 }} />

          <Box>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: 20,
                color: "#999",
                mt: 20,
              }}
            >
              Doc will be represented here.
            </Typography>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
